import React from 'react';
import irelandApi from "../irelandApi";
import qs from "qs";
import { destandard } from "../utils/commonFunctions";
import { history } from "../store";
import { toast } from "react-toastify";
import ToastMessage from '../components/common/toast-message';
import { actions } from "react-redux-form";

export const getPromotions = (displayFromDate, displayToDate, product, group) => (dispatch) => {
  dispatch({
    type: "GET_PROMOTION_LIST_PENDING",
    payLoad: []
  });
  let q = {
    display_from_date: displayFromDate,
    display_to_date: displayToDate,
    product_id: product,
    group_id: group
  };

  return irelandApi.get(`/api/admin/promotions?${qs.stringify({q: q}, {encodeValuesOnly: true})}`)
    .then((response) => {
      dispatch({type: "GET_PROMOTION_LIST_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PROMOTION_LIST_REJECTED', payLoad: error.data})
    })
};

export const getPromotion = (id) => (dispatch) => {
  dispatch({type: "GET_PROMOTION_PENDING"});
  return irelandApi.get(`/api/admin/promotions/${id}`)
    .then((response) => {
      const data = destandard({
        //photo: response.data.data.attributes.links.photo,
        ...response.data.data.attributes
      });
      dispatch({type: "GET_PROMOTION_FULFILLED", payLoad: data});

      return Promise.resolve(data);
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={`Unable to get promotion order.`}/>, {autoClose: 2000});
      dispatch({type: 'GET_PROMOTION_REJECTED', payLoad: "error"})
    })
};

export const deletePromotion = (id) => (dispatch) => {
  dispatch({type: "DELETE_PROMOTION_PENDING"});
  return irelandApi.delete(`/api/admin/promotions/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Price promotion has been deleted successfully"/>);
      dispatch({type: "DELETE_PROMOTION_FULFILLED", payLoad: id});
      dispatch(getPromotions());
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      let message = "An error occured during delete promotion";
      if (data.has_items) {
        message = data.has_items;
      }
      toast.error(<ToastMessage iconStyle="error" message={message}/>);
      dispatch({type: 'DELETE_PROMOTION_REJECTED', payLoad: error.data});

      return Promise.reject(data);
    })
};

export const savePromotion = (payLoad) => dispatch => {
  dispatch({type: "SAVE_PROMOTION_PENDING"});
  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
    return curr.value;
  });

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`promotion[group_ids][]`, value)
      });
    } else {
      formData.append(`promotion[${key}]`, payLoad[key])
    }
  });

  return irelandApi.post(`/api/admin/promotions`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Promotion has been saved successfully"/>);
      history.push('/admin/promotions');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save promotion";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.overlap_error) {
          toastMessage = errors.overlap_error;
        }
        ['display_to_date', 'groups', ].forEach((field) => {
          if (errors[field]) {
            dispatch(actions.setErrors(`deep.admin_promotion_save.${field}`, errors[field]));
          }
        });
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_PROMOTION_REJECTED', payLoad: errorData});
    })
};

export const updatePromotion = (id, payLoad) => dispatch => {
  dispatch({type: "SAVE_PROMOTION_PENDING"});

  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  if (payLoad["group_ids"]) {
    payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
      return curr.value;
    });

    if (payLoad["group_ids"].indexOf("all") > -1) {
      payLoad["all_groups"] = true;
      delete payLoad["group_ids"];
    }
  }

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`promotion[group_ids][]`, value)
      });
    } else if (`${key}` == 'special_reward' && payLoad[key] === null) {
      formData.append(`promotion[${key}]`, false);
    } else {
      formData.append(`promotion[${key}]`, payLoad[key])
    }
  });

  return irelandApi.patch(`/api/admin/promotions/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Promotion has been saved successfully"/>);
      history.push('/admin/promotions');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save promotion";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.overlap_error) {
          toastMessage = errors.overlap_error;
        }
        ['display_to_date', 'groups', ].forEach((field) => {
          if (errors[field]) {
            dispatch(actions.setErrors(`deep.admin_promotion_save.${field}`, errors[field]));
          }
        });
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_PROMOTION_REJECTED', payLoad: errorData});
    })
};

const removeNullFields = (data) => {
  const copy = {...data};
  return copy;
};



// WEBPACK FOOTER //
// ./src/actions/promotions.js